import React from 'react'
import { Typography } from 'antd'
import { isNil } from 'lodash'

import { formatDateUk } from '../../../core/utils'

import { StyledUpdatedText } from '../../../menu-curation-tasks/components/styled'
import { dishTimestampsPropType } from '../../prop-types'

const DishDetailsTimestamps = ({ timestamps }) => {
  const {
    tierOneDoneAt,
    tierOneDoneBy,
    curatedAt,
    curatedBy,
    qadAt,
    qadBy,
    qcdAt,
    qcdBy,
    autoeatUpdatedAt,
    lastModifiedByTierOneAt,
    lastModifiedByCuratorAt,
    lastModifiedByQaAt,
    lastModifiedByQcAt,
    lastRestSuggestionsAt,
    lastPubSubSuggestionsAt,
    lastModifiedByTierOne,
    lastModifiedByCurator,
    lastModifiedByQa,
    lastModifiedByQc,
  } = timestamps

  return (
    <>
      <Typography.Paragraph strong>Timestamps</Typography.Paragraph>
      <StyledUpdatedText>{`${formatDateUk(
        autoeatUpdatedAt,
      )} - last update by Autoeat`}</StyledUpdatedText>
      {!isNil(lastRestSuggestionsAt) && (
        <StyledUpdatedText>
          {`Last REST ai suggestions at: ${formatDateUk(
            lastRestSuggestionsAt,
          )}`}
        </StyledUpdatedText>
      )}
      {!isNil(lastPubSubSuggestionsAt) && (
        <StyledUpdatedText>
          {`Last PUBSUB ai suggestions at: ${formatDateUk(
            lastPubSubSuggestionsAt,
          )}`}
        </StyledUpdatedText>
      )}
      {!isNil(lastModifiedByTierOneAt) && !isNil(lastModifiedByTierOne) && (
        <StyledUpdatedText>
          {`Last modified by a tier one: ${formatDateUk(
            lastModifiedByTierOneAt,
          )} by ${lastModifiedByTierOne.email}`}
        </StyledUpdatedText>
      )}
      {!isNil(tierOneDoneAt) && !isNil(tierOneDoneBy) && (
        <StyledUpdatedText>
          {`Tier One Curated: ${formatDateUk(tierOneDoneAt)} by ${
            tierOneDoneBy.email
          }`}
        </StyledUpdatedText>
      )}

      {!isNil(lastModifiedByCuratorAt) && !isNil(lastModifiedByCurator) && (
        <StyledUpdatedText>
          {`Last modified by a curator: ${formatDateUk(
            lastModifiedByCuratorAt,
          )} by ${lastModifiedByCurator.email}`}
        </StyledUpdatedText>
      )}
      {!isNil(curatedAt) && !isNil(curatedBy) && (
        <StyledUpdatedText>
          {`Curated: ${formatDateUk(curatedAt)} by ${curatedBy.email}`}
        </StyledUpdatedText>
      )}

      {!isNil(lastModifiedByQaAt) && !isNil(lastModifiedByQa) && (
        <StyledUpdatedText>
          {`Last modified by a qa: ${formatDateUk(lastModifiedByQaAt)} by ${
            lastModifiedByQa.email
          }`}
        </StyledUpdatedText>
      )}
      {!isNil(qadAt) && !isNil(qadBy) && (
        <StyledUpdatedText>
          {`QAd: ${formatDateUk(qadAt)} by ${qadBy.email}`}
        </StyledUpdatedText>
      )}

      {!isNil(lastModifiedByQcAt) && !isNil(lastModifiedByQc) && (
        <StyledUpdatedText>
          {`Last modified by a qc: ${formatDateUk(lastModifiedByQcAt)} by ${
            lastModifiedByQc.email
          }`}
        </StyledUpdatedText>
      )}
      {!isNil(qcdAt) && !isNil(qcdBy) && (
        <StyledUpdatedText>
          {`QCd: ${formatDateUk(qcdAt)} by ${qcdBy.email}`}
        </StyledUpdatedText>
      )}
    </>
  )
}

DishDetailsTimestamps.propTypes = {
  timestamps: dishTimestampsPropType,
}

DishDetailsTimestamps.defaultProps = {
  timestamps: {},
}

export default DishDetailsTimestamps
